module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/8.fa56229f.jpg";